import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { App } from "./App";
import { maybeInitSentry } from "./observability/sentry";
import { initI18n } from "./i18n";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";

// Only fires if the user has previously accepted optional cookies. On
// first visit the CookieConsent banner inside <App /> handles the
// prompt and calls initSentry() directly on accept.
maybeInitSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});

void (async () => {
  // Initialize i18next BEFORE first render so catalogs are warm by first
  // paint and no component sees a missing-key flash. LanguageProvider
  // (mounted inside <App />) handles the runtime resolution order.
  await initI18n();
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        {/* HelmetProvider is mounted defensively so any <Seo /> consumer
            (today: marketing routes only; tomorrow: potentially in-app
            pages like a self-serve pricing change) works in both bundles
            without a silent context-missing crash. */}
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
})();
